import axios from "axios";

const KEY = "ozy_amb_token";

export const ambApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
ambApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const ambToken = { get: () => localStorage.getItem(KEY), set: (t) => localStorage.setItem(KEY, t), clear: () => localStorage.removeItem(KEY) };

export const monthLabel = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
